import React from 'react';
import { ImageViewer } from 'antd-mobile';

interface PickUpPhotoViewerProps {
    photoUrl: string | null | undefined;
    onClose: () => void;
}

const PickUpPhotoViewer: React.FC<PickUpPhotoViewerProps> = ({ photoUrl, onClose }) => {
    if (!photoUrl) return null;

    return (
        <ImageViewer
            image={photoUrl}
            visible={true}
            onClose={onClose}
            renderFooter={() => null}
        />
    );
};

export default PickUpPhotoViewer;